import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-down-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './chevron-down-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ChevronDownIconComponent {}
